module.exports = __webpack_public_path__ + "static/media/linkedin.e51549f6.svg";